module.exports = require('regenerate')(0x483).addRange(0x10350, 0x1037A);
